import React from 'react';
import InspectorCard from './inspector_card';
import Editable from '../common/editable';

export default function Agenda(props) {
	return (
		<InspectorCard header="Agenda" {...props} className="abl-agenda-card">
      <table className="abl-agenda-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Start</th>
            <th>End</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
            <Editable
              tagName="span"
              className="abl-editable-label"
              defaultText="Untitled"
              value="Do Now" />
            </td>
            <td>
            <Editable
              tagName="span"
              className="abl-editable-label"
              defaultText="Untitled"
              value="9:30" /></td>
            <td>
              <Editable
              tagName="span"
              className="abl-editable-label"
              defaultText="Untitled"
              value="10:00" />
            </td>
          </tr>
          <tr>
            <td>
              <Editable
              tagName="span"
              className="abl-editable-label"
              defaultText="Untitled"
              value="Word Work" />
            </td>
            <td>
              <Editable
              tagName="span"
              className="abl-editable-label"
              defaultText="Untitled"
              value="10:00" />
            </td>
            <td>
              <Editable
              tagName="span"
              className="abl-editable-label"
              defaultText="Untitled"
              value="10:30" />
            </td>
          </tr>
          <tr>
            <td>
              <Editable
              tagName="span"
              className="abl-editable-label"
              defaultText="Untitled"
              value="Read Aloud" />
            </td>
            <td>
              <Editable
              tagName="span"
              className="abl-editable-label"
              defaultText="Untitled"
              value="10:30" />
            </td>
            <td>
              <Editable
              tagName="span"
              className="abl-editable-label"
              defaultText="Untitled"
              value="11:00" />
            </td>
          </tr>
        </tbody>
      </table>
      <div className="abl-agenda-invite">
        <a>Invite Team Member to Edit</a>
      </div>
    </InspectorCard>
	);
};


/** WEBPACK FOOTER **
 ** ./src/js/components/schedule_inspector/agenda.js
 **/